import { Component, ViewEncapsulation, ChangeDetectionStrategy, Input } from '@angular/core';

import { SIXT_CODE } from '@shared/policies-detail/constants/company-code.constants';

@Component({
  selector: 'app-autos-policies',
  templateUrl: './autos-policies.component.html',
  styleUrls: [
    '../policies-detail/policies-detail.component.sass',
  ],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AutosPoliciesComponent {

  @Input() titleClass: string;
  @Input() companyCode: string;

  constructor() { }

  get hasCustomPolicies(): boolean {
    return this.formatCode === SIXT_CODE;
  }

  private get formatCode(): string {
    return this.companyCode?.toUpperCase();
  }

  get translateCustomKey(): string {
    return this.hasCustomPolicies ? `BOOKING_MODULE.AUTOS_CANCELLATION_POLICIES_TEXT.BY_CODE.${this.formatCode}` : '';
  }

}
